import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import styles from '../../styles/ls-request/NewLsHistory.module.scss';
import styles2 from '../../styles/wiki/PageHistory.module.scss';
import {
	getLsRequestHistory,
	storeLsRequestHistory,
	selectLsRevision,
} from '../../actions/lsRequestAction';
import { connect } from 'react-redux';
import {
	lsModelTextFields,
	rolesUnderCouncilMembers,
	nonLegDivisionRoles,
} from '../../services/constants';
import parse from 'html-react-parser';
import File from '../library/File';
import { formatDateTime } from '../../utils/helper';
import { LsFields } from '../../services/LsFields';
import { ChevronCompactLeftIcon } from '../../services/SvgLibrary';
import { getFileAndDownload } from '../../actions/fileDownloadAction';

const lsFieldList = JSON.parse(JSON.stringify(LsFields));

/**
 * LsInfoDisplay component: displays all information about a version of LS history
 * @returns LsInfoDisplay component
 */
const LsInfoDisplay = ({
	currentLS,
	isCurrent,
	version = null,
	userProfile,
	getFileAndDownload,
	fieldsToHighlight,
}) => {
	const cmRole = rolesUnderCouncilMembers.includes(userProfile.role);
	let filteredField = lsFieldList.filter(
		field =>
			!(
				cmRole &&
				(field.viewability === 'staffOnly' || field.viewability === 'none')
			)
	);
	let waivedConfidentiality = filteredField.find(
		x => x.field === 'make_first_prime_public'
	);
	waivedConfidentiality.title = 'Waived Confidentiality?';
	let excludedArray = [
		'ls_number',
		'first_prime',
		'date_received',
		'new_status',
		'new_status_requestor',
	];
	let displayLsPart = filteredField.map((ls, idx) => {
		let text = '';
		if (
			(currentLS[ls.field] ||
				ls.type === 'checkbox' ||
				ls.field === 'reintroduction') &&
			!excludedArray.includes(ls.field) &&
			!(ls.type === 'multi-select')
		) {
			if (ls.field === 'date_received') {
				text = formatDateTime(currentLS[ls.field]);
			} else if (ls.type === 'file') {
				if (currentLS[ls.field].length > 0) {
					const files = currentLS[ls.field];
					text = (
						<div key={idx}>
							{files.map((file, index) => (
								<File
									id={`lsr_${ls.field}-${index}`}
									file={file}
									getFileAndDownload={getFileAndDownload}
									key={index}
								/>
							))}
						</div>
					);
				} else {
					text = 'N/A';
				}
			} else if (ls.field === 'committee') {
				text = parse(
					currentLS[ls.field] && currentLS[ls.field].committee_name !== 'Unassigned' ? currentLS[ls.field].committee_name : ''
				);
			} else if (['first_prime', 'staff', 'submitted_by'].includes(ls.field)) {
				text = parse(currentLS[ls.field] ? currentLS[ls.field].full_name : '');
			} else if (ls.field === 'contact_person') {
				text = currentLS['contact_person'] ? (
					<>
						{currentLS['contact_person']['full_name']}
						<br />
						{currentLS['contact_person']['phone']}
						<br />
						{currentLS['contact_person']['email']}
					</>
				) : (
					''
				);
			} else if (lsModelTextFields.includes(ls.field)) {
				currentLS[ls.field] = currentLS[ls.field]
					.replace(new RegExp('&lt;', 'gi'), match => '<')
					.replace(new RegExp('&gt;', 'gi'), match => '>');
				text =
					currentLS[ls.field] && currentLS[ls.field] !== 'undefined' ? (
						<pre className={styles['pre']}>{parse(currentLS[ls.field])}</pre>
					) : (
						<pre className={styles['pre']}>N/A</pre>
					);
			} else if (
				ls.type === 'checkbox' ||
				ls.field === 'reintroduction'
			) {
				text = currentLS[ls.field] ? 'Yes' : 'No';
			} else if (['overlapping_ls', 'related_ls'].includes(ls.field)) {
				text =
					currentLS[ls.field].length > 0
						? currentLS[ls.field].map((ls_num, idx) => (
							<React.Fragment key={idx}>
								<a
									href={`${window.location.origin}/lsRequestList/${ls_num.ls_number}`}
									onClick={e => {
										e.preventDefault();
										window.open(
											`${window.location.origin}/lsRequestList/${ls_num.ls_number}`
										);
									}}>
									{ls_num.ls_number}
								</a>
								{idx === currentLS[ls.field].length - 1 ? '' : ', '}
							</React.Fragment>
						))
						: 'N/A';
			} else if (ls.field === 'associated_report_tracking') {
				text =
					currentLS[ls.field].length > 0
						? currentLS[ls.field].map((report, idx) => (
							<React.Fragment key={idx}>
								<a
									href={`${window.location.origin}/opReqs/${report.id}`}
									onClick={e => {
										e.preventDefault();
										window.open(
											`${window.location.origin}/opReqs/${report.id}`
										);
									}}>
									{report.title}
								</a>
								{idx === currentLS[ls.field].length - 1 ? '' : ', '}
							</React.Fragment>
						))
						: 'N/A';
			} else {
				text = <div>{currentLS[ls.field]}</div>;
			}

			return (
				<fieldset
					className={`${styles['fieldset-styles']} ${fieldsToHighlight.includes(ls.field) && styles['highlight']
						}`}
					id={`${ls.field}-${isCurrent ? 'left' : 'right'}`}
					key={idx}>
					<legend className={styles['fieldset-legend-styles']}>
						{ls.title}:
					</legend>
					<span className={styles['fieldset-content-styles']}>{text}</span>
				</fieldset>
			);
		} else if (!excludedArray.includes(ls.field)) {
			return (
				<fieldset
					className={`${styles['fieldset-styles']} ${fieldsToHighlight.includes(ls.field) && styles['highlight']
						}`}
					id={`${ls.field}-${isCurrent ? 'left' : 'right'}`}
					key={idx}>
					<legend className={styles['fieldset-legend-styles']}>
						{ls.title}:
					</legend>
					<span className={styles['fieldset-content-styles']}>N/A</span>
				</fieldset>
			);
		}
		return null;
	});
	return displayLsPart;
};

/**
 * NewLsHistory component
 * @param {*} props : props passed down from parent component(s)
 * @returns LsHistory Component
 */
const NewLsHistory = props => {
	const [fieldsToHighlight, setFieldsToHighlight] = useState([]);
	const [leftVersion, setLeftVersion] = useState(null); // Left dropdown selection
	const [rightVersion, setRightVersion] = useState(null); // Right dropdown selection

	let { ls_num } = useParams();
	ls_num = ls_num || props.ls_num;

	useEffect(() => {
		props.getLsRequestHistory(ls_num);
	}, []);

	// Set default values for leftVersion (newest) and rightVersion (oldest)
	useEffect(() => {
		if (props.ls_history.length > 0) {
			const newestVersion = props.ls_history[0]; // Assuming ls_history is sorted descending
			const oldestVersion = props.ls_history[props.ls_history.length - 1];
			setLeftVersion(newestVersion);
			setRightVersion(oldestVersion);
		}
	}, [props.ls_history]);

	function compareArrays(first, second) {
		first.sort();
		second.sort();
		return first.reduce((acc, ele, idx) => {
			return ele === second[idx] && acc;
		}, true);
	}

	function compareVersions(leftLs, rightLs) {
		if (!leftLs || !rightLs) return;
		const updatedFields = [];
		const nonLeg = nonLegDivisionRoles.includes(props.userProfile.role);
		let filteredField = lsFieldList.filter(
			field => !(nonLeg && field.viewability === 'staffOnly')
		);

		filteredField.forEach(field => {
			const leftValue = leftLs[field.field];
			const rightValue = rightLs[field.field];

			if (Array.isArray(leftValue)) {
				if (
					!Array.isArray(rightValue) ||
					!compareArrays(
						leftValue.map(ele => ele.id || ele),
						rightValue.map(ele => ele.id || ele)
					)
				) {
					updatedFields.push(field.field);
				}
			} else if (typeof leftValue === 'object' && leftValue !== null) {
				if (
					typeof rightValue !== 'object' ||
					leftValue.id !== rightValue.id
				) {
					updatedFields.push(field.field);
				}
			} else if (leftValue !== rightValue) {
				updatedFields.push(field.field);
			}
		});

		setFieldsToHighlight(updatedFields);
	}

	useEffect(() => {
		compareVersions(leftVersion, rightVersion);
	}, [leftVersion, rightVersion]);

	const renderDropdown = (selectedVersion, setSelectedVersion, label, idPrefix) => {

		const currentIndex = props.ls_history.findIndex(
			(ls) => ls.revision_date === selectedVersion?.revision_date
		);

		const incrementVersion = () => {
			if (currentIndex > 0) {
				setSelectedVersion(props.ls_history[currentIndex - 1]);
			}
		};

		const decrementVersion = () => {
			if (currentIndex < props.ls_history.length - 1) {
				setSelectedVersion(props.ls_history[currentIndex + 1]);
			}
		};

		return (
			<div className={styles['dropdown-container']}>
				<div className={styles['dropdown-wrapper']}>
					<button
						type="button"
						className={`btn btn-secondary mt-2 ${styles['version-btn']}`}
						onClick={incrementVersion}
						disabled={currentIndex <= 0}
					>
						↑
					</button>

					<select
						className={`btn btn-secondary mt-2 ${selectedVersion
							? `${styles['selected']} ${styles['archive']}`
							: styles['archive']
							}`}
						value={selectedVersion ? selectedVersion.revision_date : ''}
						onChange={(e) =>
							setSelectedVersion(
								props.ls_history.find(
									(ls) => ls.revision_date === e.target.value
								)
							)
						}
					>
						<option value="" disabled>
							Select a Version
						</option>
						{props.ls_history.map((ls_rev, idx) => {
							const dateTime = new Date(ls_rev.revision_date);
							return (
								<option
									key={ls_rev.revision_date}
									value={ls_rev.revision_date}
									className={
										selectedVersion?.revision_date === ls_rev.revision_date
											? `${styles['selected']} ${styles['archive']}`
											: styles['archive']
									}
								>
									{idx === 0
										? 'Current'
										: idx === props.ls_history.length - 1
											? 'Oldest'
											: ''}{' '}
									Version {props.ls_history.length - idx}: {dateTime.toLocaleString()} (EST) - Edited by {ls_rev.user}
								</option>
							);
						})}
					</select>

					<button
						type="button"
						className={`btn btn-secondary mt-2 ${styles['version-btn']}`}
						onClick={decrementVersion}
						disabled={currentIndex >= props.ls_history.length - 1}
					>
						↓
					</button>

				</div>
			</div>
		)
	};


	return (
		<div className="d-flex">
			{props.ls_history.length > 1 ? (
				<div className={styles['lsr-version-review-container']}>
					<div className="d-flex flex-row justify-content-between px-2">
						{/* LSR top section with back button */}
						{window.location.pathname.includes('history') && (
							<Link
								className={styles['return-button']}
								to={'http://localhost:3000/lsRequestList/'}
							>
								<ChevronCompactLeftIcon
									styleProp={{ verticalAlign: '-.225em' }}
								/>
								Return to LS Requests Table
							</Link>
						)}
					</div>
					<div style={{ marginTop: '-40px', marginBottom: '40px' }}>
						<h1
							className={styles2['archived-history-heading']}>
							LS #{ls_num} - {props.currentLs['ls_type']}
						</h1>
					</div>

					{/* END LSR top section with back button */}
					{/* Column header only for current and selected lsr */}
					{props.ls_history.length > 1 && (
						<>
							<>
							</>
							<div className={styles['ls-fields-container']}>
								<div className={styles['ls-sidebar-fields']}>
									{renderDropdown(leftVersion, setLeftVersion, 'Left Version')}

									{leftVersion ? (
										<LsInfoDisplay
											currentLS={leftVersion}
											isCurrent={false}
											version={true}
											userProfile={props.userProfile}
											getFileAndDownload={props.getFileAndDownload}
											fieldsToHighlight={fieldsToHighlight}
										/>
									) : (
										<p>Please select a version to display.</p>
									)}
								</div>
								<div className={styles['ls-sidebar-fields']}>
									{renderDropdown(rightVersion, setRightVersion, 'Right Version')}

									{rightVersion ? (
										<LsInfoDisplay
											currentLS={rightVersion}
											isCurrent={false}
											version={true}
											userProfile={props.userProfile}
											getFileAndDownload={props.getFileAndDownload}
											fieldsToHighlight={fieldsToHighlight}
										/>
									) : (
										<p>Please select a version to display.</p>
									)}
								</div>
							</div>
						</>

					)}
				</div>
			) : (
				<div
					className={`d-flex align-items-center flex-column justify-content-center p-5 rounded-3 w-100 ${styles['tasks-empty']}`}
				>
					<img
						src="/img/no-results-found.svg"
						className="h-50 mb-4"
						alt="No history found"
					/>
					<p className="text-muted">
						No change history found for this LS request.
					</p>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = state => {
	return {
		userProfile: state.userReducer.userProfile,
		currentLs: state.lsRequestsReducer.lsHistoryCurrent,
		ls_history: state.lsRequestsReducer.lsHistoryList,
		selectedLsRevision: state.lsRequestsReducer.selectedLsHistory,
		selectLsIndex: state.lsRequestsReducer.selectLsHistoryIndex,
	};
};

const mapDispatchToProps = {
	getLsRequestHistory,
	storeLsRequestHistory,
	selectLsRevision,
	getFileAndDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewLsHistory);
